<template>
  <div>
    <p>Aquesta tarja serveix per <strong>destacar un tweet</strong> en plataformes que no siguen Twitter.</p>
    <p>Només cal engantxar l'adreça d'un tweet. Si el tweet té imatge adjunta, es posarà per defecte com a imatge de fons.</p>
    <p>
      Aquest model de tarja accepta els següents formats:
    </p>
    <ul>
      <li><strong>1:1</strong>: model genèric per a compartir en la majoria de xarxes socials (Facebook, Instagram, canals de Telegram i Whatsapp, etc.).</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'tweet-help'
}
</script>
